import { render, staticRenderFns } from "./ElaborateCourseShare.vue?vue&type=template&id=3c675354&scoped=true&"
import script from "./ElaborateCourseShare.vue?vue&type=script&lang=js&"
export * from "./ElaborateCourseShare.vue?vue&type=script&lang=js&"
import style0 from "./ElaborateCourseShare.vue?vue&type=style&index=0&id=3c675354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c675354",
  null
  
)

export default component.exports